import React, {useState} from 'react'
import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    // Select,
    // Form,
    Input,
    // DatePicker
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
// const { Item } = Form;
const { Search } = Input;
// const { Option } = Select;
const { confirm } = Modal;

const Exhibitors = () => {
  const navigate = useNavigate()

  const [filterConfig, setFilterConfig] = useState({
    payment_id: "",
    type: "tenant",
    status: "open",
})

  function ActionBtn(row) {
    const items = [
        {
            label: (
                <div onClick={()=> navigate('/edit-exhibitor')}>
                    View Info
                </div>
            ),
            key: '1',
        },
       
        {
            label: (
                <div style={{color: 'red'}} onClick={showDeleteConfirm}>
                    Delete
                </div>
            ),
            key: '2',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  const showDeleteConfirm = () => {
      confirm({
        title: 'Are you sure delete this Property?',
        icon: <ExclamationCircleFilled />,
      //   content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
        },
        onCancel() {
        },
      });
    };

  
  const data = [
      {
        key: '1',
        exhibitor_info: 'Big area',
      },
      {
        key: '2',
        exhibitor_info: 'Small Area',
      },
      {
        key: '3',
        exhibitor_info: 'Medium Area',
      },
      {
        key: '4',
        exhibitor_info: 'Extra Large Area',
      },
  ];

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
    ));
};  
  return (
      <Layout className='page'>
          <Navbar navKey={'exhibitors_nav'}/>
          <Layout className='content-container'>
            <Row>
              <Col span={14} className='header-container p-4'>
                  EXHIBITORS
              </Col>
              <Col span={10} className='pt-4'>
                <Row>
                  <Col span={14} className='p-4'>
                    <Search placeholder="input search text" size='medium' allowClear onSearch={onSearch} style={{ width: 250 }} />
                  </Col>
                  <Col span={10} className='p-4'>
                    <Button className='button-color btn-header' onClick={() => navigate('/add-exhibitor')} type="primary">+ Add New Exhibitors</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='page-content'>
              <Col span={24}>
                <AntDTable
                  tableHeaders={[
                    "Exhibitor Info",
                  ]}
                  headerSelector={[
                    "exhibitor_info",
                  ]}
                  tableData={data}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  // loading={showLoader}
                  // isClickable={true}
                  // rowClickPath={"/patients/profile"}
                  tablePages={10}
                  // handleTableChange={handleTableChange}
                  // filterConfig={filterConfig}
                  // totalSize={totalSize}
                  isSearch={true}
                />
              </Col>
            </Row>
        </Layout>
      </Layout>
  )
}

export default Exhibitors
